import React from 'react'
import dayjs from 'dayjs'
import { useVip } from '../../../app/hooks'
import saveIconVip from '../images/vip/save_icon.png'
import viewIconVip from '../images/vip/view_icon.png'
import downloadIconVip from '../images/vip/download_icon.png'
import exportIconVip from '../images/vip/export_icon.png'
import removeWatermarkIconVip from '../images/vip/remove_watermark_icon.png'

import saveIconVvip from '../images/vvip/save_icon.png'
import viewIconVvip from '../images/vvip/view_icon.png'
import downloadIconVvip from '../images/vvip/download_icon.png'
import exportIconVvip from '../images/vvip/export_icon.png'
import removeWatermarkIconVvip from '../images/vvip/remove_watermark_icon.png'

import saveIconSvip from '../images/svip/save_icon.png'
import viewIconSvip from '../images/svip/view_icon.png'
import downloadIconSvip from '../images/svip/download_icon.png'
import exportIconSvip from '../images/svip/export_icon.png'
import removeWatermarkIconSvip from '../images/svip/remove_watermark_icon.png'
import { useVipKind } from '../../../app/hooks'
type Props = {
  stats?: any
  group?: any
  onPressKeyAccountClick?: any
  onPayMain?: any
  expireDays?: number
}

const VipHoverPopover = ({
  stats,
  group,
  onPressKeyAccountClick,
  onPayMain,
  expireDays = 0
}: Props) => {
  const stat = stats
  const { isVip, isSVip, isVVip } = useVip()
  const currentVipKind = useVipKind()
  const expireTime = stat && stat.expireTime
  const expireText = (() => {
    if (typeof expireDays === 'number' && isVip) {
      if (expireDays > 30)
        return dayjs.unix(Number(expireTime)).format('YYYY/MM/DD')
      if (expireDays <= 30 && expireDays > 0) return `将于${expireDays}天后到期`
      if (expireDays === 0) return '将于今日到期'
      return `已过期${Math.abs(expireDays)}天`
    }
    return null
  })()

  const totalNum =
    stat && typeof stat.totalNum !== 'undefined'
      ? stat.totalNum < 10000
        ? stat.totalNum
        : (stat.totalNum / 10000).toFixed(1) + '万'
      : '· · ·'

  const limit =
    stat && typeof stat.limitPhotoNum !== 'undefined'
      ? stat.limitPhotoNum < 10000
        ? stat.limitPhotoNum
        : stat.limitPhotoNum / 10000 + '万张'
      : '· · ·'
  const memberCount =
    stat && typeof stat.memberCount !== 'undefined'
      ? stat.memberCount < 10000
        ? stat.memberCount
        : (stat.memberCount / 10000).toFixed(1) + '万'
      : '· · ·'

  const storageStatus = (() => {
    if (!stat) return null
    const limitN = Number(stat.limitPhotoNum) || 0
    const totalN = Number(stat.totalNum) || 0
    const ratio = limitN === 0 ? 0 : totalN / limitN
    if (ratio >= 1) {
      return {
        text: '已满',
        style: {
          background: '#FE5049',
          color: '#ffffff'
        }
      }
    } else if (ratio >= 0.9) {
      return {
        text: '将满',
        style: {
          background: '#FFDCA5',
          color: '#402012'
        }
      }
    }
    return null
  })()

  const memberDescText = () => {
    const recommendedKind =
      stat && typeof stat.topNeedVipKind !== 'undefined'
        ? Number(stat.topNeedVipKind)
        : null
    const getLevelLabel = (kind: number) => {
      switch (kind) {
        case 2:
          return '超级会员'
        case 1:
          return '基础会员'
        case 3:
          return '高级会员'
        default:
          return '超级会员'
      }
    }

    if (!isVip) {
      if (expireDays < 0) {
        return '续费团队会员可享30+权限'
      } else {
        return '开通团队会员可享30+权限'
      }
    } else if (isSVip) {
      if (expireDays > 30) {
        return '已享全部30+会员权益'
      } else {
        return '续费超级会员可享全部30+权益'
      }
    } else if (isVVip || isVip) {
      if (expireDays > 30) {
        return recommendedKind !== null
          ? `升级${getLevelLabel(recommendedKind)}可享30+权益`
          : '开通团队会员可享30+权益'
      } else {
        return `续费${getLevelLabel(currentVipKind || 0)}可享30+权益`
      }
    }
  }

  const activateBtnText = () => {
    if (!isVip) {
      if (expireDays < 0) {
        return '立即续费'
      } else {
        return '立即开通'
      }
    } else if (!isSVip) {
      if (expireDays > 30) {
        return '立即升级'
      } else {
        return '立即续费'
      }
    } else {
      if (expireDays > 30) {
        return '会员中心'
      } else {
        return '立即续费'
      }
    }
  }

  const icons = isSVip
    ? {
        save: saveIconSvip,
        view: viewIconSvip,
        download: downloadIconSvip,
        export: exportIconSvip,
        remove: removeWatermarkIconSvip
      }
    : isVVip
    ? {
        save: saveIconVvip,
        view: viewIconVvip,
        download: downloadIconVvip,
        export: exportIconVvip,
        remove: removeWatermarkIconVvip
      }
    : {
        save: saveIconVip,
        view: viewIconVip,
        download: downloadIconVip,
        export: exportIconVip,
        remove: removeWatermarkIconVip
      }

  return (
    <div className="vip-hover-popover">
      <div className="vip-popover-inner">
        <div className="vip-photo-row">
          <div className="vip-photo-top">
            <div className="vip-photo-label">
              团队照片
              {storageStatus && (
                <span
                  className="vip-storage-badge"
                  style={{ ...storageStatus.style }}
                >
                  {storageStatus.text}
                </span>
              )}
            </div>
            <div className="vip-photo-value">
              {totalNum}
              {limit === -1 ? '张' : <>/{limit}</>}
            </div>
          </div>
          {limit !== -1 && (
            <div className="vip-progress-wrap">
              <div className="vip-progress-track">
                <div
                  className="vip-progress-fill"
                  style={{
                    width:
                      stat && stat.limitPhotoNum
                        ? `${Math.min(
                            100,
                            Math.round(
                              (Number(stat.totalNum || 0) /
                                Number(stat.limitPhotoNum || 1)) *
                                100
                            )
                          )}%`
                        : '0%',
                    background:
                      stat &&
                      Number(stat.totalNum || 0) >=
                        Number(stat.limitPhotoNum || 0)
                        ? '#FE5049'
                        : '#7AB8FF'
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <div className="vip-team-row">
          <div className="vip-team-top">
            <div className="vip-team-label">团队人数</div>
            <div className="vip-team-value">{memberCount}人</div>
          </div>
        </div>

        <div
          className={
            'vip-member-card ' +
            (isSVip
              ? 'vip-super'
              : isVVip
              ? 'vip-advanced'
              : isVip
              ? 'vip-basic'
              : '')
          }
        >
          <div className="vip-member-top">
            <div className="vip-member-title">
              {isSVip
                ? '超级会员'
                : isVVip
                ? '高级会员'
                : isVip
                ? '基础会员'
                : '团队会员'}
              {expireDays !== null && expireDays <= 30 ? (
                <span>{expireText}</span>
              ) : null}
            </div>
            {stat?.memberType === 2 || stat?.memberType === 3 ? (
              <div className="vip-member-expire">自动续费中</div>
            ) : expireDays !== null && expireDays > 30 ? (
              <div className="vip-member-expire">{expireText}到期</div>
            ) : null}
          </div>
          <div className="vip-divider" />
          <div className="vip-member-desc">{memberDescText()}</div>

          <div className="vip-benefits-icons">
            <div className="vip-icon-item">
              <img src={icons.save} alt="save" />
            </div>
            <div className="vip-icon-item">
              <img src={icons.view} alt="view" />
            </div>
            <div className="vip-icon-item">
              <img src={icons.download} alt="download" />
            </div>
            <div className="vip-icon-item">
              <img src={icons.export} alt="export" />
            </div>
            <div className="vip-icon-item">
              <img src={icons.remove} alt="watermark" />
            </div>
          </div>

          <div className="vip-benefits-cta vip-benefits-cta-in-card">
            <button className="vip-cta-primary" onClick={() => onPayMain()}>
              {activateBtnText()}
            </button>
            <button
              className="vip-cta-secondary"
              onClick={() => onPressKeyAccountClick()}
            >
              大客户定制会员
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VipHoverPopover
